import { render, staticRenderFns } from "./CitiesList.vue?vue&type=template&id=859b80fc&scoped=true"
import script from "./CitiesList.vue?vue&type=script&lang=ts"
export * from "./CitiesList.vue?vue&type=script&lang=ts"
import style0 from "./CitiesList.vue?vue&type=style&index=0&id=859b80fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859b80fc",
  null
  
)

export default component.exports